import { createApp } from 'vue';
import { createPinia } from 'pinia';
import './style.css';
import App from './App.vue';
import { router } from '@/routes';
import { config } from '@/config';
import { initialiseSentry } from '@/util/sentry/initialisation';
import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import Mixpanel from '@/integrations/Mixpanel';

function initialiseApp() {
  const app = createApp(App);
  const release =
    document?.querySelector('meta[name="release"]')?.getAttribute('content') || undefined;

  initialiseSentry({
    app,
    enabled: config.sentryEnabled,
    dsn: config.sentryDsn,
    release,
    tunnelUrl: `${config.apiBaseUrl}/sentry-tunnel`,
    environment: config.env || 'local',
    replaysEnabled: config.sentryReplaysEnabled,
    router,
  });

  const pinia = createPinia();
  app.use(router);
  app.use(pinia);
  app.mount('#app');

  // Session store is initialized by router guards
  // Initialisation of mixpanel storage depends on correlationId
  router.isReady().then(() => Mixpanel.instance.init());
  countries.registerLocale(en);
}

initialiseApp();
